/**
 * House pricing: what a product costs when nobody has said otherwise.
 *
 * Twenty dollars a unit, or ten for a hundred and fifty. The pack price is a
 * flat total chosen on its own, not a discount rate applied to the single price
 * — ten singles would be $200, and nothing in the system derives $150 from that
 * or $20 from $150.
 *
 * It lives in shared, not in the seed script, because three places must agree:
 * the seed that stocks a new shop, the admin form's one-tap fill, and the copy
 * that tells a customer what the standing offer is. Three copies of "15000"
 * drift the moment one of them is edited.
 */
export const HOUSE_UNIT_PRICE_CENTS = 2000;
export const HOUSE_PACKS = [{ packUnits: 10, packPriceCents: 15000 }];
//# sourceMappingURL=house.js.map